export default __webpack_public_path__ + "static/media/HackCBS.e52d7b34.svg";